import { useRoutes } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';
import MainRoutes from './MainRoutes';
import MainApplicationsRoutes from './MainApplicationsRoutes';
import LoginRoutes from './LoginRoutes';
import CarsRoutes from './CarsRoutes';
import PromooveRoutes from './PromooveRoutes';
import EventsRoutes from './EventsRoutes';
import ConfigRoutes from './ConfigRoutes';
import ErrorRoutes from './ErrorRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const { user } = useAuth();
  const serviceRoutes = [LoginRoutes, ErrorRoutes];

  const userRoutesValues = {
    autobuy: [MainApplicationsRoutes],
    public: [EventsRoutes],
    user: [],
    admin: [MainRoutes, EventsRoutes, MainApplicationsRoutes, ConfigRoutes, CarsRoutes, PromooveRoutes],
    manager: [MainRoutes, EventsRoutes, MainApplicationsRoutes, CarsRoutes],
    vendor: [EventsRoutes, MainRoutes, MainApplicationsRoutes, CarsRoutes],
    finance: [EventsRoutes, CarsRoutes]
  };
  const currentUserRoutes = user?.role ? userRoutesValues[user?.role] : userRoutesValues['user'];
  const routes = useRoutes(currentUserRoutes ? [...serviceRoutes, ...currentUserRoutes] : serviceRoutes);

  return routes;
}
